import { createSelector } from 'reselect';

export const storefrontSelector = state => state.storefront;

export const ordersFilterSelector = createSelector(storefrontSelector, storefront => storefront.ordersFilter);

export const productsFilterSelector = createSelector(storefrontSelector, storefront => storefront.productsFilter);
